import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LOCALES = ['en', 'zh-CN'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_STORAGE_KEY = 'wf-locale';

function detectInitialLocale(): Locale {
  try {
    const stored = JSON.parse(localStorage.getItem(LOCALE_STORAGE_KEY) ?? 'null');
    const persisted = stored?.state?.locale;
    if (SUPPORTED_LOCALES.includes(persisted)) return persisted;
  } catch {
    // localStorage unavailable or malformed - fall through to browser detection.
  }
  if (typeof navigator !== 'undefined' && navigator.language?.toLowerCase().startsWith('zh')) return 'zh-CN';
  return 'en';
}

// Every namespace file under i18n/locales/<locale>/<namespace>.json is picked
// up automatically - adding a new namespace only means adding the two JSON
// files, never touching this init.
const modules = import.meta.glob<{ default: Record<string, unknown> }>('/src/i18n/locales/*/*.json', { eager: true });
const resources: Record<string, Record<string, Record<string, unknown>>> = {};
for (const path in modules) {
  const match = /\/i18n\/locales\/([^/]+)\/([^/]+)\.json$/.exec(path);
  if (!match) continue;
  const [, locale, namespace] = match as unknown as [string, string, string];
  resources[locale] ??= {};
  resources[locale][namespace] = modules[path]!.default;
}

void i18next.use(initReactI18next).init({
  resources,
  lng: detectInitialLocale(),
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export default i18next;
